import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, from, mergeMap, of } from 'rxjs';

import { AuthFacade } from '~backoffice/app/~store/facades/auth.facade';
import { GlobalFacade } from '~backoffice/app/~store/facades/global.facade';
import { ROUTES } from '../constants/routes.constants';

export const NON_AUTHENTICATED_GUARD = ():
  | Observable<UrlTree | boolean>
  | boolean => {
  const authFacade = inject(AuthFacade);
  const globalFacade = inject(GlobalFacade);
  const router = inject(Router);

  return authFacade.accessToken$.pipe(
    mergeMap(accessToken => {
      if (accessToken) {
        const currentUrl = globalFacade.routeData?.currentUrl;
        return from(router.navigateByUrl(currentUrl || ROUTES.home));
      }
      return of(true);
    })
  );
};
